module.exports = __webpack_public_path__ + "img/bm.21debc2e.svg";